
import CallOutgoing from "../../../assets/filled/CallOutgoing.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CallOutgoingIcon({ className, dataTestid = "CallOutgoingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CallOutgoing data-testid={dataTestid} className={classes} {...rest} />
  );
}
